/**
 * Which sidebar entries an admin-only rule lets through. A plain function, so
 * the decision is tested without rendering the sidebar.
 *
 * Only a confirmed admin (`true`) gets the entry: `undefined` — the answer is
 * still pending, or the request failed — hides it like `false` does. Fail
 * closed: these entries are shortcuts, their pages stay reachable by URL.
 */
export function adminOnlyNavItem(
  item: JSX.Element | null,
  admin: boolean | undefined,
): JSX.Element | null {
  return admin === true ? item : null;
}
